import { useState, useEffect } from 'react'
import axios from 'axios'
import { Input, Select } from 'antd'
import MyIcon from '../../components/general/icon'

const FitnessVideoRibbon = ({
  isAddVisible,
  filterValue,
  setFilterValue
}) => {
  const [keywordsValue, setKeywordsValue] = useState('')
  const [seriesList, setSeriesList] = useState([])
  const [searchBoxVisible, setSearchBoxVisible] = useState(false)

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setFilterValue({ ...filterValue, keywords: keywordsValue })
    }, 300)
    return () => clearTimeout(timeoutId)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keywordsValue])

  useEffect(() => {
    axios.post('/admin/content/fitness_series/list/get', { 
      per_page: 1000 
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setSeriesList(response.data.series)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }, [])

  let items = [
    {  
      value: '', 
      label: '全部健身系列'
    },
    ...seriesList.map((item) => (
      {
        value: item.oid,
        label: item.title
      }
    ))
  ]

  const handleBlur = () => {
    if (!keywordsValue) {
      setSearchBoxVisible(false)
      setFilterValue({ ...filterValue, keywords: '' })
    }
  }

  const clickSeriesFilter = (value) => {
    setFilterValue({ ...filterValue, series_oid: value })
  }

  return (
    <div className='ribbon-page'>
      <div className='ribbon-container'>
        <div className='ribbon-button-primary' onClick={() => { isAddVisible() }}>新增健身视频</div>
        <Select
          placeholder="筛选健身系列"
          options={items}
          style={{height: '32px', width: '200px'}}
          onChange={(value) => clickSeriesFilter(value)}
        />
        {!searchBoxVisible ? 
          <div className='ribbon-condition' onClick={() => { setSearchBoxVisible(true) }}>
            <span><MyIcon name='sousuo'/></span>
            <p>搜索</p>
          </div>
        : <Input
            style={{width: '260px'}}
            prefix={<MyIcon name='sousuo'/>}
            maxLength={64}
            autoFocus
            placeholder='输入健身视频标题'
            value={keywordsValue}
            onChange={(e) => setKeywordsValue(e.target.value)}
            onBlur={handleBlur}
            allowClear
          />
        }
      </div>
    </div>
  )
}

export default FitnessVideoRibbon
